





































































































import _ from 'lodash';
import { Vue, Component } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import AuthorityScreenPermission from '@/domain/security/authority-screen-permission.entity'
import AuthorityService from '@/domain/security/authority.service';
import ScreenEntity from '@/domain/security/screen.entity';
import Permission from '@/domain/security/permission.entity';
import UpdatePermission from '@/domain/security/update-permission.entity';
import AuthorityStore from '@/domain/security/authority.store';
import Authority from '@/domain/security/authority.entity';
import MembersModal from './members-modal.vue'

const PERMISSIONS_FLAT_MAPPER = (screen: ScreenEntity) => screen.permissions;

@Component({
  components: {
    MembersModal,
  },
})
export default class GroupComponent extends Vue {
  groups: string[][] = [];

  authorityName: string = this.$route.params.authorityName;

  loading: boolean = false;

  showMembersModal: boolean = false;

  modalKey: number = 0;

  renderModal: boolean = false;

  groupId: string = '';

  loadingSave: boolean = false;

  isUpdateSecurity: boolean = false;

  authorityScreensPermissions: AuthorityScreenPermission = new AuthorityScreenPermission();

  unchangedPermissions: Permission[] = [];

  get changes(): UpdatePermission[] {
    const permissions: Permission[] = this.authorityScreensPermissions.screens
      .flatMap(PERMISSIONS_FLAT_MAPPER);
    const changes: UpdatePermission[] = [];
    for (let i = 0; i < permissions.length; i += 1) {
      if (permissions[i].grantedAccess && !this.unchangedPermissions[i].grantedAccess) {
        changes.push(UpdatePermission.newAdd(permissions[i].name));
      }
      if (!permissions[i].grantedAccess && this.unchangedPermissions[i].grantedAccess) {
        changes.push(UpdatePermission.newRemove(permissions[i].name));
      }
    }
    return changes;
  }

  savePermissions(): void {
    this.loadingSave = true;
    AuthorityService.updatePermissions(this.authorityName, this.changes)
      .then(() => VbSnackbarService.showSuccess('Permissões salvas com sucesso.'))
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingSave = false);
  }

  async created() {
    AuthorityService.getAuthorityGroups(this.authorityName)
      .then(groups => this.groups = groups)
      .catch(VbSnackbarService.handleHttpError);
    this.getUpdatePermission();
    await this.createData();
  }

  getUpdatePermission(): void {
    AuthorityStore.fetchedAuthority().then((response: Authority) => {
      this.isUpdateSecurity = response.isUpdateSecurity();
    });
  }

  close() {
    this.showMembersModal = false;
    this.modalKey += 1;
  }

  openModal(groupId: string) {
    this.showMembersModal = true;
    this.renderModal = false;
    this.$nextTick(() => this.renderModal = true)
    this.groupId = groupId;
  }

  back() {
    this.$router.push('/security')
  }

  createData() {
    this.loading = true;
    AuthorityService.authotitiesPermissions(this.authorityName)
      .then((response) => {
        this.authorityScreensPermissions = new AuthorityScreenPermission(response);
        this.unchangedPermissions = _.cloneDeep(this.authorityScreensPermissions.screens).flatMap(
          PERMISSIONS_FLAT_MAPPER,
        );
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loading = false);
  }
}
